import React from "react";
import {Container, Grid, Header, Image} from "semantic-ui-react";
import {APP} from '../../../constants';
import {FormattedMessage} from "react-intl";

export const KnowCity = ({details}) => {

    const {know_title, know_text, know_image} = details;

    const image = APP.cities + '/know_image/' + know_image;

    return (
        <Container as="section" fluid className="section-know-city">
            <Grid columns="equal">
                <Grid.Column>
                    <div className="content">
                        <Header as="h2">
                            {
                                know_title || <FormattedMessage id="Conhecendo a cidade"/>
                            }

                        </Header>
                        <div dangerouslySetInnerHTML={{__html: know_text}}/>
                        {/*<p>*/}
                        {/*    It is a long established fact that a reader will be distracted by*/}
                        {/*    the readable content of a page when looking at its layout. The*/}
                        {/*    point of using Lorem Ipsum is that it has a more-or-less normal*/}
                        {/*    distribution of letters, as opposed to using 'Content here*/}
                        {/*</p>*/}
                        {/*<Item.Group unstackable>*/}
                        {/*    <Item>*/}
                        {/*        <div>*/}
                        {/*            <FiMapPin size="3rem" style={{marginRight: "2rem"}}/>*/}
                        {/*        </div>*/}
                        {/*        <Item.Content>*/}
                        {/*            <Item.Header>Header</Item.Header>*/}
                        {/*            <Item.Description>*/}
                        {/*                <p>*/}
                        {/*                    There are many variations of passages of Lorem Ipsum*/}
                        {/*                    available, but the majority have suffered alteration in*/}
                        {/*                    some form.*/}
                        {/*                </p>*/}
                        {/*            </Item.Description>*/}
                        {/*        </Item.Content>*/}
                        {/*    </Item>*/}
                        {/*    <Item>*/}
                        {/*        <div>*/}
                        {/*            <FiMapPin size="3rem" style={{marginRight: "2rem"}}/>*/}
                        {/*        </div>*/}
                        {/*        <Item.Content>*/}
                        {/*            <Item.Header>Header</Item.Header>*/}
                        {/*            <Item.Description>*/}
                        {/*                <p>*/}
                        {/*                    There are many variations of passages of Lorem Ipsum*/}
                        {/*                    available, but the majority have suffered alteration in*/}
                        {/*                    some form.*/}
                        {/*                </p>*/}
                        {/*            </Item.Description>*/}
                        {/*        </Item.Content>*/}
                        {/*    </Item>*/}
                        {/*    <Item>*/}
                        {/*        <div>*/}
                        {/*            <FiMapPin size="3rem" style={{marginRight: "2rem"}}/>*/}
                        {/*        </div>*/}
                        {/*        <Item.Content>*/}
                        {/*            <Item.Header>Header</Item.Header>*/}
                        {/*            <Item.Description>*/}
                        {/*                <p>*/}
                        {/*                    There are many variations of passages of Lorem Ipsum*/}
                        {/*                    available, but the majority have suffered alteration in*/}
                        {/*                    some form.*/}
                        {/*                </p>*/}
                        {/*            </Item.Description>*/}
                        {/*        </Item.Content>*/}
                        {/*    </Item>*/}
                        {/*</Item.Group>*/}
                    </div>
                </Grid.Column>
                <Grid.Column only={'large screen'}>
                    {
                        know_image && <Image src={image} floated="right"/>
                    }
                </Grid.Column>
            </Grid>
        </Container>
    );
};
